export class VideoModel {
    name:string = "";
    src:string = "";
    desc: string = "";

    constructor(){}
}